<template>
   <div>
     <v-card>
     <div v-if="type === 'progress'">
        <v-content>
          <v-progress-circular
            :size="70"
            :width="7"
            color="blue"
            indeterminate
          ></v-progress-circular>
        </v-content>
       <v-card-title class="justify-center">
         <p>
           {{message}}
         </p>
       </v-card-title>
     </div>

     <div v-if="type === 'message'">
       <v-card-title class="justify-center pb-0">
         <p>
           {{message}}
         </p>
       </v-card-title>
       <v-card-actions class="justify-center">
         <v-btn
           color="blue"
           flat="flat"
           v-on:click="dismiss()"
         >
           OK
         </v-btn>
       </v-card-actions>
     </div>

       <div v-if="type === 'messageOnly'">
         <v-card-title class="justify-center pb-0">
           <p>
             {{message}}
           </p>
         </v-card-title>
       </div>
     </v-card>
   </div>
</template>

<script>
  export default {
    props: ['type', 'message', 'lengthType'],
    data () {
      return {
      }
    },
    methods: {
      dismiss () {
        this.$emit('dismiss')
      }
    }
  }
</script>

<style scoped>
  .v-card {
    background-color: white;
    text-align: center;
  }

  .v-progress-circular {
    margin-top: 20px;
    margin-bottom: 20px;
  }

   p {
     font-size: 1.3em;
     color: blue;
   }

</style>



// WEBPACK FOOTER //
// src/components/Shared/Dialog.vue